export default "__VITE_ASSET__BQMDMul___"